import { useLevelPlaySurface } from '../surface'

/**
 * Cor de borda derivada do estado da resposta — usada pelos kinds de seleção
 * (AtThePlace, ThisOrThat) para sinalizar acerto, erro e escolha.
 *
 * Vivia duplicado por domínio (`Levels/hooks/` e `Show/hooks/`), e as duas
 * cópias diferiam **apenas** no contexto que consumiam. Como `answerIsRight` e
 * `answerIsWrong` estão na superfície de jogo, o hook nunca precisou de
 * domínio: é agnóstico disfarçado.
 */
export const useBorderColor = () => {
  const { answerIsRight, answerIsWrong } = useLevelPlaySurface()

  let borderColor = 'border-gray-200'
  if (answerIsRight) {
    borderColor = 'border-success'
  } else if (answerIsWrong) {
    borderColor = 'border-danger'
  }

  const getBorderColor = (props = {}) => {
    const {
      hasSelection = false,
      isSelected = false,
      borderColor: _borderColor = 'border-gray-200'
    } = props
    let borderColor = _borderColor

    if (answerIsRight && (!hasSelection || isSelected)) {
      borderColor = 'border-success'
    } else if (answerIsWrong && (!hasSelection || isSelected)) {
      borderColor = 'border-danger'
    } else if (hasSelection && isSelected) {
      borderColor = 'border-primary'
    }

    return borderColor
  }

  return { borderColor, getBorderColor }
}
